export const commonsamples_French = [
    {
        id: 0,
        chatname: "Vérifiez la grammaire",
        promptsandresponses: [
            {
             id: 1,
             prompt: "J'étais là.",
             response: "J'étais là."
            },
        ]
    },

    {
        id:1,
        chatname:"Extraire des mots-clés",
        promptsandresponses:[
            {
             id:1,
             prompt:"Les voitures électriques existent depuis un certain temps, mais ce n'est que ces dernières années qu'elles sont devenues plus populaires. Avec l'inquiétude croissante concernant l'environnement et le réchauffement climatique, de nombreuses personnes envisagent maintenant les voitures électriques comme une alternative aux voitures traditionnelles fonctionnant à l'essence. L'un des principaux avantages des voitures électriques est qu'elles ne produisent aucune émission. Cela signifie qu'elles n'émettent pas de gaz nocifs dans l'atmosphère, ce qui est une bonne nouvelle pour notre planète. De plus, elles sont beaucoup plus silencieuses que les voitures traditionnelles, ce qui en fait un excellent choix pour la conduite en ville.",
             response:"Voitures électriques, environnement, réchauffement climatique, alternative, voitures fonctionnant à l'essence, aucune émission, gaz nocifs, atmosphère, planète, plus silencieuses, conduite en ville."
            },
        ]
    },

    {
        id:2,
        chatname:"Résumé",
        promptsandresponses:[
            {
             id:1,
             prompt:"Les voitures électriques existent depuis un certain temps, mais ce n'est que récemment qu'elles sont devenues plus populaires. Avec l'augmentation de la préoccupation pour l'environnement et le réchauffement climatique, de nombreuses personnes envisagent maintenant les voitures électriques comme une alternative aux voitures traditionnelles à essence. L'un des principaux avantages des voitures électriques est qu'elles ne produisent aucune émission. Cela signifie qu'elles n'émettent pas de gaz nocifs dans l'atmosphère, ce qui est une bonne nouvelle pour notre planète. De plus, elles sont beaucoup plus silencieuses que les voitures traditionnelles, ce qui en fait un excellent choix pour la conduite en ville.",

             response:"Les voitures électriques gagnent en popularité en raison de la préoccupation croissante pour l'environnement et le réchauffement climatique. Elles ne produisent aucune émission et sont beaucoup plus silencieuses que les voitures traditionnelles, ce qui en fait une excellente option pour la conduite en ville."
            },
        ]
    },

    {
        id:3,
        chatname:"Compact",
        promptsandresponses:[
            {
             id:1,
             prompt:"Les voitures électriques existent depuis un certain temps, mais ce n'est que récemment qu'elles sont devenues plus populaires. Avec la préoccupation croissante pour l'environnement et le réchauffement climatique, de nombreuses personnes envisagent maintenant les voitures électriques comme une alternative aux voitures traditionnelles à essence. L'un des principaux avantages des voitures électriques est qu'elles ne produisent aucune émission. Cela signifie qu'elles n'émettent pas de gaz nocifs dans l'atmosphère, ce qui est une bonne nouvelle pour notre planète. De plus, elles sont beaucoup plus silencieuses que les voitures traditionnelles, ce qui en fait un excellent choix pour la conduite en ville.",

             response:"Les voitures électriques sont devenues plus populaires en raison des préoccupations environnementales. Elles ne produisent aucune émission, ce qui en fait un excellent choix pour la conduite en ville."
            },
        ]
    },

    {
        id:4,
        chatname:"Description",
        promptsandresponses:[
            {
             id:1,
             prompt:"sac en cuir, marron, moins de 29 $",

             response:`Le sac en cuir est un accessoire élégant et fonctionnel qui est parfait pour toutes les occasions. Fabriqué à partir de cuir marron de haute qualité, ce sac est durable et conçu pour durer. Il dispose d'un compartiment principal spacieux qui peut contenir tous vos essentiels, y compris votre téléphone, votre portefeuille, vos clés et plus encore. Le sac a un design simple mais élégant, avec une seule bandoulière qui le rend facile à transporter. Il est léger et confortable, et la bandoulière réglable garantit un ajustement parfait pour tous les types de corps.
             Le mieux de tout, ce sac en cuir est disponible pour moins de 29 $, ce qui en fait une option abordable pour quiconque veut un sac de haute qualité sans se ruiner. Que vous fassiez des courses, que vous vous rendiez au travail ou que vous sortiez en ville, ce sac en cuir est l'accessoire parfait pour compléter votre look.`
            },
        ]
    },

     {
        id:5,
        chatname:"Email",
        promptsandresponses:[
            {
             id:1,
             prompt:"Conférence parents-enseignants, 12h30 mercredi, Expéditeur : Tom",
             response:`Objet : Rappel - Conférence parents-enseignants, mercredi à 12h30
             \n\nChers parents,\n\nJ'espère que cet e-mail vous trouvera en bonne santé. Juste un petit rappel que nous avons la conférence parents-enseignants prévue à 12h30 le mercredi. Cette conférence est une excellente occasion pour discuter de la progression de votre enfant à l'école et aborder toutes les préoccupations ou questions que vous pourriez avoir.\
             \nComme vous le savez tous, la conférence se tiendra en ligne cette année et vous recevrez un lien pour rejoindre la conférence par e-mail. Veuillez vous assurer de vérifier votre messagerie avant le début de la conférence. Si vous rencontrez des difficultés techniques, n'hésitez pas à me contacter et je serai heureux de vous aider. J'ai hâte de vous rencontrer tous et de discuter de la progression de votre enfant à l'école. Nous avons beaucoup de choses à discuter, alors veuillez venir préparé avec toutes les questions ou préoccupations que vous pourriez avoir.
             \n\nMerci et je vous verrai tous mercredi.
             \n\nCordialement,
             \n\nTom`
            },
        ]
    },

    {
        id:6,
        chatname:"Histoire",
        promptsandresponses:[
            {
             id:1,
             prompt:"un oiseau, un chien, une journée ensoleillée",

             response:`Il était une fois, lors d'une journée ensoleillée, un oiseau perché sur une branche d'arbre, chantant un air mélodieux. L'oiseau appréciait le soleil chaud et l'air frais. Soudain, un chien arriva en courant vers l'arbre, aboyant bruyamment. L'oiseau fut effrayé et s'envola, mais le chien continua à le poursuivre.\nL'oiseau volait aussi vite qu'il le pouvait, mais le chien était rapide et déterminé. Alors que la poursuite continuait, l'oiseau remarqua que le chien ne cherchait pas à lui faire du mal, mais plutôt à jouer. L'oiseau se posa sur une branche voisine, toujours effrayé mais curieux. Le chien essaya de grimper à l'arbre, mais c'était trop haut pour lui.\nL'oiseau réalisa que le chien n'était pas une menace et décida de jouer avec lui. Il se mit à gazouiller et à voler autour, invitant le chien à jouer. Le chien était ravi et remuait la queue joyeusement. Les deux commencèrent à se poursuivre autour de l'arbre, passant un moment merveilleux.
             \nAu fur et à mesure que la journée avançait, le soleil commençait à se coucher et l'oiseau savait qu'il était temps de partir. Il fit un dernier chant d'adieu au chien et s'envola. Le chien le regarda disparaître à l'horizon, se sentant un peu triste mais aussi heureux pour le plaisir qu'ils avaient partagé.
             À partir de ce jour-là, le chien venait souvent à l'arbre, espérant revoir l'oiseau. Bien qu'ils ne jouent plus jamais ensemble, le souvenir de cette journée ensoleillée resta dans le cœur du chien pour toujours. C'était un rappel de la joie qui découle des amitiés inattendues et de la beauté de la nature lors d'une journée ensoleillée.`
            },
        ]
    },

    {
        id:7,
        chatname:"Améliorer",
        promptsandresponses:[
            {
             id:1,
             prompt:"Les voitures électriques gagnent en popularité en raison de la préoccupation croissante pour l'environnement et le réchauffement climatique. Elles ne produisent aucune émission et sont beaucoup plus silencieuses que les voitures traditionnelles, ce qui en fait une excellente option pour la conduite en ville.",

             response:"Les véhicules électriques sont de plus en plus populaires en raison des préoccupations croissantes pour l'environnement et le réchauffement climatique. Ces véhicules ne produisent aucune émission et fonctionnent plus silencieusement que les voitures traditionnelles, ce qui en fait un choix idéal pour la conduite en ville."
            },
        ]
    }
    

]
